import { materialColors } from "../game/engine";
import { canvasTheme } from "../game/theme";
import "./pop.css";

export type ThemeId = "base" | "pop";

export const themes: Array<{ id: ThemeId; label: string; name: string; summary: string }> = [
  { id: "pop", label: "ポップ", name: "Pop", summary: "クリーム地に太いアウトラインとずらし影、丸ゴシックと明るい4色" },
  { id: "base", label: "クラシック", name: "Classic", summary: "以前の main のノート風デザイン" },
];

export const DEFAULT_THEME: ThemeId = "pop";
/** Fired after the palette changes so canvases can redraw. */
export const THEME_EVENT = "wordphysics:theme";
const STORAGE_KEY = "wordphysics.theme";

const popFonts = "https://fonts.googleapis.com/css2?family=Fredoka:wght@500;600;700&family=Zen+Maru+Gothic:wght@500;700;900&display=swap";

const popCanvas = {
  paper: "#fff7e8",
  ink: "#1e1b3a",
  frame: "rgba(30,27,58,.8)",
  pattern: "rgba(30,27,58,.28)",
  grid: "rgba(30,27,58,.05)",
  gridMajor: "rgba(30,27,58,.1)",
  floor: "#ffd59a",
  sling: "#1e1b3a",
  signal: "#ff5a36",
  materials: { glass: "#8fe3ff", laminated: "#4da3ff", brick: "#ff7a45", core: "#18b377", resonance: "#9b6bff", dampener: "#ffc233" },
};
const baseCanvas = structuredClone(canvasTheme);
const baseMaterialColors = { ...materialColors };

function isTheme(value: string | null): value is ThemeId {
  return themes.some((item) => item.id === value);
}

export function readThemeChoice(): ThemeId {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (isTheme(saved)) return saved;
  } catch { /* storage is optional */ }
  return DEFAULT_THEME;
}

export function applyTheme(theme: ThemeId) {
  document.documentElement.dataset.theme = theme;
  const palette = theme === "pop" ? popCanvas : baseCanvas;
  Object.assign(canvasTheme, palette, { materials: { ...palette.materials } });
  Object.assign(materialColors, theme === "pop" ? popCanvas.materials : baseMaterialColors);
  if (theme === "pop" && !document.querySelector(`link[href="${popFonts}"]`)) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = popFonts;
    document.head.append(link);
  }
  window.dispatchEvent(new Event(THEME_EVENT));
}

export function setThemeChoice(theme: ThemeId) {
  try { localStorage.setItem(STORAGE_KEY, theme); } catch { /* storage is optional */ }
  applyTheme(theme);
}

/** ?theme=<id> previews a theme without changing the saved choice. */
export function initTheme(): ThemeId {
  const requested = new URLSearchParams(window.location.search).get("theme");
  const theme = isTheme(requested) ? requested : readThemeChoice();
  applyTheme(theme);
  return theme;
}
